<template>
  <div class="page">
    <main style="margin-top: 20px">
      <el-tabs v-model="queryType" type="card">
        <el-tab-pane label="支付明细" name="支付明细">
          <div class="div-header-select">
            <div class="div-center">
              <!-- <div>支付日期：</div> -->
              <el-date-picker
                style="width: 250px"
                size="medium"
                v-model="paidDate"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="至"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <div class="div-center">
              <el-select
                v-model="type"
                clearable
                placeholder="请选择订单类型"
                style="width: 100%"
              >
                <el-option label="充值" value="充值"></el-option>
                <el-option label="退款" value="退款"></el-option>
                <el-option label="缴费" value="缴费"></el-option>
              </el-select>
            </div>
            <div class="div-center">
              <el-select
                v-model="payType"
                clearable
                placeholder="请选择支付渠道"
                style="width: 100%"
              >
                <el-option label="微信" value="微信"></el-option>
                <el-option label="支付宝" value="支付宝"></el-option>
                <el-option
                  label="银行对公账户"
                  value="银行对公账户"
                ></el-option>
                <el-option
                  label="银行个人账户"
                  value="银行个人账户"
                ></el-option>
                <el-option label="现金" value="现金"></el-option>
                <el-option label="其它" value="其它"></el-option>
              </el-select>
            </div>
            <div class="div-center">
        <el-input
          @keyup.enter.native="initQuery"
          style="width: 280px"
          placeholder="姓名或手机号"
          v-model="nameOrPhone"
          clearable
          maxlength="13"
          @clear="initQuery"
          size="medium"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
        <el-input
          @keyup.enter.native="initQuery"
          style="width: 280px; margin-left: 15px;"
          placeholder="房号"
          v-model="houseName"
          clearable
          maxlength="13"
          @clear="initQuery"
          size="medium"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>
            <!-- <el-button
              size="medium"
              @click="query(pageIdx - 1)"
              style="margin-left: 15px"
              >查询</el-button
            > -->
          </div>
          <el-table
            @header-click="headerClickReceipt"
            :data="listData"
            @sort-change="sortChange"
            style="width: 100%; margin-top: 5px;"
            height="calc(100vh - 200px)"
            :border=true
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <img
                src="../../assets/list-none.png"
                alt=""
                width="400"
                class="table-empty"
              />
              <div>空荡荡的～暂无数据！</div>
            </template>

            <!-- <el-table-column
              prop="paidTime"
              label="支付时间"
              width="180px"
              align="center"
            >
            </el-table-column>
             -->
            <el-table-column
              prop="paidTime"
              label="支付时间"
              width="150px"
              align="center"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column label="金额(元)" width="160px" align="right">
              <template slot-scope="scope">
                <strong v-if="scope.row.type === '退款'" style="color: red">{{
                  numFormat(scope.row.fee)
                }}</strong>
                <strong v-else style="color: green">{{
                  numFormat(scope.row.fee)
                }}</strong>
              </template>
            </el-table-column>
            <el-table-column
              prop="type"
              width="80px"
              label="订单类型"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="payType"
              width="80px"
              label="支付渠道"
              align="center"
            >
            </el-table-column>
            <el-table-column label="付款人" width="100px" align="center">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="400px"
                  trigger="click"
                >
                  <div>{{scope.row.payer.realname + " " + scope.row.payer.phone}}</div>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{scope.row.payer.realname}}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="收款人" width="100px" align="center">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="400px"
                  trigger="click"
                  v-if="scope.row.receiver"
                >
                  <div>{{scope.row.receiver.realname + " " + scope.row.receiver.phone}}</div>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{scope.row.receiver.realname}}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
             <el-table-column
              v-if="!receiptInput"
              prop="receipt"
              width="280px"
              align="center"
              key="receipt_1"
            >
              <template slot="header">
                <div style="color: #409eff">
                  <span>支付凭据 </span>
                  <i class="el-icon-search"></i>
                </div>
              </template>
            </el-table-column>
             <el-table-column
              v-if="receiptInput"
              prop="receipt"
              label="支付凭据"
              width="280px"
              align="center"
              key="receipt_2"
            >
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="queryReceipt"
                  size="mini"
                  placeholder="支付凭据"
                  clearable
                  v-focus
                  maxlength="50"
                  @blur="recoverReceipt"
                  @keyup.enter.native="query(0)"
                  @clear="clearInput"
                />
              </template>
              <!-- 
                  autofocus是vue中input的原生属性,element也支持这种方法,
                  但是如果el-input组件外面还有其他组件, 就会导致autofocus失效。
                  解决办法：

                  自定义指令

                  在全局定义一个自动获取焦点的自定义指令，在所有组件中都可以使用v-focus来自动获取焦点。
                  v-focus 是自定义全局指令  
                  参见：https://blog.csdn.net/weixin_46074961/article/details/120350817?spm=1001.2101.3001.6650.1&utm_medium=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link
                  -->
            </el-table-column>
            <el-table-column label="关联账单" width="80px" align="center">
            
              <!-- <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="showBillsDialog(scope.row)"
                  :disabled="scope.row.billNum === 0"
                  >{{ scope.row.billNum }}</el-button
                >
              </template> -->
              <!-- 点击此单元格在提示框中显示数据列表 -->
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  trigger="click"
                  v-if="scope.row.billNum>0"
                >
                  <el-table :data="scope.row.bills">
                    <el-table-column width="150" label="房源">
                      <template slot-scope="props">
                        <!-- 将单元格显示为按钮状态   （好看） -->
                        <span align="center" style="padding: 5px 5px">
                          <el-button
                            round
                            size="mini"
                            style="cursor: default; padding: 5px 10px"
                          >
                            <div>
                              {{
                                props.row.areaName
                                  ? props.row.areaName +
                                    "：" +
                                    props.row.houseName
                                  : props.row.houseName
                              }}
                            </div>
                          </el-button>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="150"
                      property="pricingName"
                      label="收费项目"
                    ></el-table-column>
                    <el-table-column width="150" label="开始时间">
                      <template slot-scope="props">
                        <span>{{ long2day(props.row.billStart) }}</span>
                        <!-- long2second 是将时间戳转换成时分秒 -->
                        <!-- <span>{{ long2second(props.row.billStart) }}</span> -->
                      </template>
                    </el-table-column>
                    <el-table-column width="150" label="结束时间">
                      <template slot-scope="props">
                        <span>{{ long2day(props.row.billEnd) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="150" label="账单金额(元)">
                      <template slot-scope="scope">
                        <strong>{{
                          numFormat(scope.row.paidAmount / 100)
                        }}</strong>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{
                      scope.row.billNum
                    }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
              <!-- <template slot-scope="props">
                <span>{{ props.row.comment }}</span>
              </template> -->

              <template scope="scope">
                <div v-if="!scope.row.edit">
                  <a
                    v-if="scope.row.comment"
                    style="cursor: pointer"
                    @click="
                      (scope.row.edit = !scope.row.edit),
                        (scope.row.tmpComment = scope.row.comment)
                    "
                    >{{ scope.row.comment }}</a
                  >
                  <a
                    v-else
                    style="cursor: pointer; color: #c0c4cc"
                    @click="
                      (scope.row.edit = !scope.row.edit),
                        (scope.row.tmpComment = scope.row.comment)
                    "
                    >点击编辑备注</a
                  >
                </div>
                <div v-else>
                  <el-input
                    v-model="scope.row.tmpComment"
                    size="mini"
                    style="width: 300px"
                    maxlength="200"
                    placeholder="编辑备注"
                    clearable
                    v-focus
                  />
                  <el-button
                    style="margin-left: 5px; padding: 3px"
                    @click="
                      (scope.row.edit = !scope.row.edit), submit(scope.row)
                    "
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                  ></el-button>
                  <el-button
                    style="margin-left: 5px; padding: 3px"
                    @click="
                      (scope.row.edit = !scope.row.edit),
                        (scope.row.tmpComment = '')
                    "
                    type="danger"
                    icon="el-icon-close"
                    circle
                    size="mini"
                  ></el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="是否开票" width="100px" align="center">
              <template slot-scope="scope">
                <el-switch
                  @change="changeItemState(scope.row.invoiceFlag)(scope.row.id)"
                  v-model="scope.row.invoiceFlag"
                  active-text=""
                  inactive-text=""
                >
                </el-switch>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="info"
                  icon="el-icon-edit"
                  plain
                  size="mini"
                  @click="editBills(scope.row)"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  size="mini"
                  @click="deleteBills(scope.row)"
                ></el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <footer>
            <el-pagination
              :current-page.sync="pageIdxPai"
              @size-change="handleSizeChangePai"
              @current-change="handleCurrentChangePai"
              :page-size="pageSizePai"
              layout="total, sizes, prev, pager, next, jumper"
              :total="itemTotal"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </footer>
        </el-tab-pane>

        <el-tab-pane label="资金统计" name="资金统计">
          <div class="div-header-select">
            <div class="div-center">
              <div>统计时段：</div>
              <el-date-picker
                style="width: 250px"
                size="medium"
                v-model="dateRangeCount"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="至"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <el-row type="flex" class="row-bg">
            <el-col :span="5" align="center">
              <!-- 总入账金额 -->
              <div
                id="incomeAmountDetails"
                style="margin-top: 20px; width: 100%; height: 250px"
              ></div>
            </el-col>
            <el-col :span="5" align="center">
              <!-- 总退款金额 -->
              <div
                id="refundAmount"
                style="margin-top: 20px; width: 100%; height: 250px"
              ></div>
            </el-col>
            <!-- 实际入账金额 -->
            <el-col :span="7" align="center">
            </el-col>
            <!-- 待缴金额 -->
            <el-col :span="7" align="center">
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="银行对账" name="银行对账">
          <div class="div-header-select">
            <div class="div-center">
              <div>对账时段：</div>
              <el-date-picker
                style="width: 250px"
                size="medium"
                v-model="dateRangeCheck"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="至"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <el-button
              size="medium"
              @click="exportFile"
              style="margin-left: 15px"
              >导出对账单</el-button
            >
            <el-button
              size="medium"
              @click="showDialogUpload"
              style="margin-left: 15px"
              >导入银行报表</el-button
            >
          </div>
          <el-table
            :data="checkList"
            style="width: 100%;margin-top: 5px;"
            height="calc(100vh - 200px)"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <img
                src="../../assets/list-none.png"
                alt=""
                width="400"
                class="table-empty"
              />
              <div>未查询到银行对账数据，请先导入银行报表！</div>
            </template>
            <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="借">
                        <span>{{ props.row.jie }}</span>
                      </el-form-item>
                      <el-form-item label="贷">
                        <span>{{ props.row.dai }}</span>
                      </el-form-item>
                      <el-form-item label="余额">
                        <span>{{ props.row.balance }}</span>
                      </el-form-item>
                      <el-form-item label="对方账号">
                        <span>{{ props.row.bankNumber }}</span>
                      </el-form-item>
                      <el-form-item label="渠道标志">
                        <span>{{ props.row.cause }}</span>
                      </el-form-item>
                      <el-form-item label="摘要">
                        <span>{{ props.row.digest }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
            <el-table-column prop="tradeDate" label="交易日期" align="center">
            </el-table-column>
            <el-table-column label="系统收款金额" align="center">
              <template slot-scope="scope">
                <strong style="color: green">{{
                  numFormat(scope.row.sysbalance / 100)
                }}</strong>
              </template>
            </el-table-column>
            <el-table-column label="银行收款金额" align="center">
              <template slot-scope="scope">
                <strong style="color: black">{{
                  numFormat(scope.row.daiNum)
                }}</strong>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="对方户名" width="200px" align="center">
            </el-table-column>
            <el-table-column prop="checkType" label="对账渠道" align="center">
            </el-table-column>
            <el-table-column prop="result" label="对账结果" align="center">
              <template slot-scope="scope">
                <strong
                  style="color: green"
                  v-if="scope.row.result == '一致'"
                  >{{ scope.row.result }}</strong
                >
                <strong style="color: red" v-else>{{
                  scope.row.result
                }}</strong>
              </template>
            </el-table-column>
            <el-table-column prop="checkTime" label="对账时间" align="center">
            </el-table-column>
            <el-table-column
              prop="checkComment"
              label="对账描述"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="receipt" label="记账凭据" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="showReceiptDialog(scope.row)"
                  :disabled="scope.row.receipt === '未生成'"
                  >{{ scope.row.receipt }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="artificialCheck(scope.row.id)"
                  :disabled="
                    scope.row.result == '一致' ||
                    (scope.row.dai == 0 && scope.row.jie > 0)
                  "
                  >对账</el-button
                >
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  size="mini"
                  @click="deleteItem(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <footer>
      <el-pagination
        @size-change="handleSizeChangeCheck"
        @current-change="handleCurrentChangeCheck"
        :current-page="pageIdxCheck"
        :page-size="pageSizeCheck"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
        </el-tab-pane>
      </el-tabs>
    </main>

    
     <el-dialog
      :visible.sync="payTogetherVisible"
      :title="titleName"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="payTogetherClose"
    >
      <div class="div-2" style="margin-top: 15px">
        <div>
          <div class="div-3-title">
            应收总金额：<span style="color: #1296db">{{
              numFormat(this.totalAmount / 100)
            }}</span>
          </div>
        </div>
        <div>
          <div class="div-3-title">
            实收总金额：
            <span style="color: #008b45">{{
              numFormat(this.paidAmount / 100)
            }}</span>
          </div>
        </div>
        <div >
          <div class="div-3-title" >待缴总金额： <span style="color: red;">{{numFormat(this.arrearageAmount/100)}}</span></div>
        </div>
      </div>
      <el-table
        :data="billList"
        style="width: 100%"
        max-height="275"
        border
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column label="房源" width="190px" align="center">
          <template slot-scope="props">
            <span align="center" style="padding: 5px 5px">
              <el-button
                round
                size="mini"
                style="cursor: default; padding: 5px 10px"
              >
                <div>
                  {{
                    props.row.areaName
                      ? props.row.areaName + "：" + props.row.houseName
                      : props.row.houseName
                  }}
                </div>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="billStartStr" label="开始时间" align="center">
        </el-table-column>
        <el-table-column prop="billEndStr" label="结束时间" align="center">
        </el-table-column>
        <el-table-column prop="pricingName" label="收费项目" align="center">
        </el-table-column>
        <el-table-column label="应收金额(元)" align="right">
          <template slot-scope="scope">
            <strong>{{ numFormat(scope.row.totalAmountStr) }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="实收金额(元)" align="right">
          <template slot-scope="scope">
            <strong
              :style="{
                color: scope.row.paidAmountStr > 0 ? '#008B45' : '',
              }"
              >{{ numFormat(scope.row.paidAmountStr) }}</strong
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="div-2" style="margin-top: 15px">
        <div class="div-2">
          <div class="div-2-title">付款人姓名</div>
          <el-input v-model="formInput.payerName"></el-input>
        </div>
        <div class="div-2">
          <div class="div-2-title">付款人手机号</div>
          <el-input v-model="formInput.payerPhone"></el-input>
        </div>
      </div>
      <div class="div-2" style="margin-top: 15px">
        <div class="div-2">
          <div class="div-2-title">支付金额（元）</div>
          <div slot="reference" class="name-wrapper">
            <el-input-number
              v-model="formInput.paidAmount"
              style="width: 100%"
              :precision="2"
              :min="0"
            ></el-input-number>
          </div>
        </div>
        <div class="div-2">
          <div class="div-2-title">支付方式</div>
          <el-select
            v-model="formInput.payType"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="微信" value="微信"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="银行对公账户" value="银行对公账户"></el-option>
            <el-option label="银行个人账户" value="银行个人账户"></el-option>
            <el-option label="现金" value="现金"></el-option>
            <el-option label="其它" value="其它"></el-option>
          </el-select>
        </div>
      </div>
      <div class="div-2" style="margin-top: 15px">
        <div class="div-2">
          <div class="div-2-title">支付凭据</div>
          <el-input v-model="formInput.receipt"></el-input>
        </div>
        <div class="div-2">
          <div class="div-2-title">备注</div>
          <el-input v-model="formInput.comment"></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closePayTogether" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitAdd()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogUploadVisible"
      :before-close="uploadClose"
      title="批量导入数据"
      width="50%"
    >
      <div>
        银行报表导入时，系统会对微信渠道(即对方户名为“财付通支付科技有限公司”)
      </div>
      <div>的记录进行自动对账，其它支付渠道需手动对账</div>
      <file-upload type="银行账单信息导入" :orgID="uploadOrgID"></file-upload>
    </el-dialog>

    <el-dialog
      :visible.sync="checkDialogVisible"
      title="手动对账"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="80px">
        <div class="div-2">
          <div style="width: 10vw">支付渠道：</div>
          <el-select
            v-model="formCheck.checkType"
            clearable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="微信" value="微信"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="银行对公账户" value="银行对公账户"></el-option>
            <el-option label="银行个人账户" value="银行个人账户"></el-option>
            <el-option label="现金" value="现金"></el-option>
            <el-option label="其它" value="其它"></el-option>
          </el-select>
        </div>
        <div class="div-2" style="margin-top: 15px">
          <div style="width: 10vw">备注：</div>
          <el-input
            maxlength="200"
            v-model="formCheck.checkComment"
            type="textarea"
            style=""
          ></el-input>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialogVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="checkSave"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogReceiptVisible"
      title="记账凭据"
      width="85%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2" style="margin-top: 15px">
        <div>
          <div class="div-3-title">
            银行名称：
            {{ this.debit.bank_name }}
          </div>
        </div>
        <div>
          <div class="div-3-title">
            到账金额：
            <span style="color: #008b45">
              {{ numFormat(this.debit.total_amount) }}
            </span>
          </div>
        </div>
        <div>
          <div class="div-3-title">
            到账时间：
            {{ this.debit.trans_time }}
          </div>
        </div>
      </div>
      <el-table
        :data="credits"
        style="width: 100%"
        max-height="275"
        border
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>

        <el-table-column
          prop="renter_name"
          label="租客姓名"
          width="100px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="house_name"
          label="房号"
          width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover placement="top-start" width="400px" trigger="click">
              <div>{{ scope.row.house_name }}</div>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium"
                  >{{ scope.row.house_name }}
                </el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="duration"
          label="账单周期"
          width="160px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="pricing_name"
          label="收费项目"
          width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="total_amount"
          label="应收金额(元)"
          width="200px"
          align="right"
        >
          <template slot-scope="scope">
            <strong>{{ numFormat(scope.row.total_amount) }}</strong>
          </template>
        </el-table-column>
        <el-table-column
          prop="paid_amount"
          label="实收金额(元)"
          width="200px"
          align="right"
        >
          <template slot-scope="scope">
            <strong
              :style="{
                color: scope.row.paid_amount > 0 ? '#008B45' : '',
              }"
              >{{ numFormat(scope.row.paid_amount) }}</strong
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="paid_time"
          label="支付时间"
          width="160px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="trans_id" label="流水号" align="center">
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="receiptPageIdx"
          :page-size="receiptPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="receiptTotal"
          :page-sizes="[10, 20, 30, 40, 50]"
        >
        </el-pagination>
      </footer>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Decimal } from "decimal.js";
import { Loading } from "element-ui";
import mixins from "../../minix";
import FileUpload from "./FileUpload";
let _vue;

let interval;

export default {
  name: "home",

  mixins: [mixins],
  components: { FileUpload },

  data() {
    return {
      uploadOrgID:"",//上传文件需要传递的组织id参数uploadOrgID
      nameOrPhone: "", // 根据姓名或手机号模糊查询
      houseName: "", // 根据房号查询
      totalAmount: "", //应收总金额
      paidAmount: "", //实收总金额
      arrearageAmount: "", //需缴费总金额
      billIdList: [],
      titleName:"",
      billList: [],
      queryReceipt: "", // 支付凭据查询
      paidDate: this.defaultDateRange(),
      dateRangeCount: this.defaultDateRange(),
      dateRangeCheck: this.defaultDateRange(),
      dialogUploadVisible: false,
      dialogReceiptVisible: false,
      payTogetherVisible: false,
      dialogVisible: false,
      checkDialogVisible: false,
      receiptInput: false,
      formInput: {},
      formCheck: {},
      pageIdx:0,
      pageIdxPai: 0,
      pageSizePai: 20,
      pageIdxCheck: 0,
      pageSizeCheck: 20,
      itemTotal: 0,
      listData: [],
      orderID: "",
      receiptPageIdx: 0,
      receiptPageSize: 10,
      receiptTotal: 0,
      debit: {
        bank_name: "",
        total_amount: "",
        trans_time: "",
      },
      credits: [],
      paidTime: "",
      payer: {
        realname: "",
        phone: "",
      },

      leftTimeStr: "",
      payType: "",
      type: "",
      queryType: "支付明细",
      checkList: [],
      
      option: {
        title: {
          text: 0,
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: (v) => {
            return v.data.name + " ￥" + this.numFormat(v.data.value);
          },
        },
        legend: {
          orient: "vertical",
          // left: 0,
          bottom: 0,
          right: 0,
        },
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
            label: {
              normal: {
                position: "inner",
                show: false,
              },
            },
            emphasis: {},
          },
        ],
      },
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);

    _vue = this;
  },

  watch: {
    dateRangeCount() {
      this.setCartogram();
    },
    dateRangeCheck() {
      // this.initQuery();
      this.query(this.pageIdxCheck-1)
    },
    paidDate() {
      // this.initQuery();
      this.query(this.pageIdxPai-1)
    },
    payType() {
      // this.initQuery();
      this.query(this.pageIdxPai-1)
    },
    type() {
      // this.initQuery();
      this.query(this.pageIdxPai-1)
    },
    queryType() {
      if (this.queryType=="支付明细"){
      this.query(0)
      }else if (this.queryType=="资金统计"){
      this.setCartogram();
      }else if (this.queryType=="银行对账"){
      this.query(0)
      }else{
      this.initQuery();
      }
    },
  },

  // mounted() {
  //   this.setCartogram();
  // },
  methods: {
    // 设置饼图 divID、 账单金额、饼图标题、饼图数据
    setPieData(divId, titleText, titleSubtext, pieData, colors) {
      let divData = this.$echarts.init(document.getElementById(divId));
      let divDataPie = { ...this.option };
      divDataPie.title.text = titleText;
      divDataPie.title.subtext = titleSubtext;
      divDataPie.series[0].data = pieData;
      divDataPie.title.textStyle = {
        fontSize: 25,
      };
      // 总入账金额
      if (divId == "incomeAmount"|| divId=="awaitIncomeAmount") {
        divDataPie.series[0].radius = "60%";
        divDataPie.legend = {
          orient: "vertical",
          // left: 0,
          bottom: 50,
          right: 0,
        };
      } else {
        divDataPie.series[0].radius = "50%";
      }
      divDataPie.series[0].itemStyle = {
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowColor: "rgba(0, 0, 0, 0.5)",
        normal: {
          color: function (params) {
            //自定义颜色
            var colorList = colors;
            return colorList[params.dataIndex];
          },
        },
      };
      divData.setOption(divDataPie);
    },
    
    setCartogram() {
      this.incomeAmountDetailsPie();
      this.refundAmountPie();
    },
     // 入账金额明细
    incomeAmountDetailsPie() {
      
      let data = {
        orgID: this.$route.query.orgID,
      };
      if (Array.isArray(this.dateRangeCount)) {
          data.paidStart = parseInt(this.dateRangeCount[0].getTime() / 1000);
          data.paidEnd = parseInt(
            this.dateRangeCount[1].getTime() / 1000 + 60 * 60 * 24 - 1
          );
        }
      var amount = "￥0.00";
      var pieData = [];
      var colors = ["#FFA011", "#CC7A00", "#228822", "#2CB12C", "#5CD65C"];
      
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "post",
        url: "finances/income",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            const item = value.data.data;
            pieData = [
              { value: item.topupOnline / 100, name: "微信充值" },
              { value: item.topupOffline / 100, name: "人工充值" },
              { value: item.billOnline / 100, name: "微信缴费" },
              { value: item.billOffline / 100, name: "人工缴费" },
              { value: item.billSys / 100, name: "其它缴费" },
            ];
            amount =
              "￥" +
              this.numFormat(
                (item.topupOnline +
                  item.topupOffline +
                  item.billOnline +
                  item.billOffline +
                  item.billSys) /
                  100
              );
          }
          // 入账金额明细
          this.setPieData(
            "incomeAmountDetails",
            amount,
            "总入账金额",
            pieData,
            colors
          );
          
        })
        .catch(() => {
          // 入账金额明细
          this.setPieData(
            "incomeAmountDetails",
            amount,
            "总入账金额",
            pieData,
            colors
          );
        })
          .finally(() => {
            loading.close();
          });
    },
    // 退款金额
    refundAmountPie() {
      let data = {
        orgID: this.$route.query.orgID,
      };
      if (Array.isArray(this.dateRangeCount)) {
          data.paidStart = parseInt(this.dateRangeCount[0].getTime() / 1000);
          data.paidEnd = parseInt(
            this.dateRangeCount[1].getTime() / 1000 + 60 * 60 * 24 - 1
          );
        }
      var amount = "￥0.00";
      var pieData = [];
      var colors = ["#777777", "#999999"];
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "finances/refund",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            const item = value.data.data;
            pieData = [
              { value: item.refundOnline / 100, name: "微信退款" },
              { value: item.refundOffline / 100, name: "人工退款" },
            ];
            amount =
              "￥" +
              this.numFormat((item.refundOnline + item.refundOffline) / 100);
          }
          // 退款总金额
          this.setPieData(
            "refundAmount",
            amount,
            "总退款金额",
            pieData,
            colors
          );
        })
        .catch(() => {
          // 退款总金额
          this.setPieData(
            "refundAmount",
            amount,
            "总退款金额",
            pieData,
            colors
          );
        })
        .finally(()=>{
          loading.close();
        });
    },
     closePayTogether(){
      
      this.billIdList=[]
      this.payTogetherVisible = false

    } ,
    
    payTogetherClose(done) {
      this.billIdList=[]
      done()

    },
    submitAdd() {
      if (!this.formInput.payerName || this.formInput.payerName.length <= 0) {
        this.$message.error("请输入付款人姓名");
        return;
      }
      if (!this.formInput.payerPhone || this.formInput.payerPhone.length <= 0) {
        this.$message.error("请输入付款人电话");
        return;
      }
      if (!this.formInput.paidAmount || this.formInput.paidAmount <= 0) {
        this.$message.error("请输入付款金额");
        return;
      }
      if (!this.formInput.payType || this.formInput.payType.length <= 0) {
        this.$message.error("请选择支付方式");
        return;
      }
      let data = {}
      let url="porders/edit"
        data={
          orderID:  this.formInput.id,
          payerName: this.formInput.payerName,
          payerPhone: this.formInput.payerPhone,
          payType: this.formInput.payType,
          fee: this.formInput.paidAmount*100,
          receipt: this.formInput.receipt,
          comment: this.formInput.comment,
          orgID:this.$route.query.orgID ,
        }
        
      
      
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: url,
        data: data,
      })
        .then((value) => {
          loading.close();
          if (value.data.code == 0) {
            this.$message.success(value.data.message);
            this.payTogetherVisible = false;
            this.dialogBillsVisible = false
            this.closePayTogether()
            this.query(this.pageIdx - 1);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },
    editBills(row) {
      this.titleName="编辑订单"
      this.rgState = true
      let billsData ={}

      let billsDataT=[]
          row.bills.forEach((item) => {
          item.billStartStr = Utils.long2day(item.billStart * 1000);
          item.billEndStr = Utils.long2day(item.billEnd * 1000);
          item.paidAmountStr = item.paidAmount / 100;
          item.unpaidAmountStr = item.unpaidAmount / 100;
          item.totalAmountStr = item.totalAmount / 100;
          billsDataT.push(item);
        });

        billsData.bills=billsDataT
        billsData.orders=[row]
      // this.handleSelectionChange([billsData]);
      

        this.formInput = [];
        this.billIdList = [];
        this.billList = [];
        // 应收总额
        this.totalAmount = 0;
        // 实收总额
        this.paidAmount = 0;
        // 欠费总额
        this.arrearageAmount = 0;
        billsData.bills.forEach((item) => {
            this.totalAmount += item.totalAmount;
            this.paidAmount += item.paidAmount;
            item.show = false;
            this.billIdList.push(item.id);
            this.billList.push(item);
          });
          this.arrearageAmount = this.totalAmount - this.paidAmount;

          this.$set(this.formInput, "id", row.id);
          this.$set(this.formInput, "paidAmount", row.fee );
          this.$set(this.formInput, "payerName", row.payer.realname);
          this.$set(this.formInput, "payerPhone", row.payer.phone);
          this.$set(this.formInput, "payType", row.payType);
          this.$set(this.formInput, "receipt", row.receipt);
          this.$set(this.formInput, "comment", row.comment);
      // this.payTogether();
      
        this.payTogetherVisible = true;
    },

    
    deleteBills(item) {
      let _vue = this;
      this.$confirm(`是否删除该笔支付？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });

        axios({
          method: "post",
          url: "porders/delete",
          data: {
            orderID: item.id,
          },
        }).then((value) => {
          if (value.data.code === 0) {
            this.dialogBillsVisible = false;
            _vue.$message.success(value.data.message);
            _vue.query(_vue.pageIdx - 1);
          } else {
            _vue.$message.error(value.data.message);
          }
        })
        .finally(()=>{
          loading.close();
        });
      });
    },
    
    clearInput() {
      this.receiptInput = false;
      this.query(0);
    },
    recoverReceipt(event) {
      if (!this.queryReceipt) {
        this.receiptInput = false;
      }
    },
    headerClickReceipt(column, event) {
      if (column.property == "receipt") {
        this.receiptInput = true;
      }
    },
    // 排序
    sortChange(e) {
      this.timeSort = e.order;
      this.pageIdx = 0;
      this.query(0);
    },
    // 默认的日期：当天
    defaultDate() {
      let now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    // 默认的时段：当月
    defaultDateRange() {
      let now = new Date();
      let mStart = new Date(now.getFullYear(), now.getMonth(), 1);
      let mEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return [mStart, mEnd];
    },
    // 显示记账凭据信息
    showReceiptDialog(row) {
      (this.debit = {
        bank_name: "",
        total_amount: "",
        trans_time: "",
      }),
        (this.credits = []),
        (this.dialogReceiptVisible = true);
      this.orderID = row.id;
      this.queryReceipts(0);
    },
    queryReceipts(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }
      let data = {
        pageSize: this.receiptPageSize,
        pageIdx: pageIdx,
        orderID: this.orderID,
      };
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "banks/records/receipt",
        data: data,
      })
        .then((value) => {
          if (value.data.code === 0) {
            this.debit = value.data.data.debit;
            this.debit.total_amount = new Decimal(this.debit.total_amount)
              .div(new Decimal(100))
              .toNumber();
            value.data.data.credits.forEach((item) => {
              item.total_amount = new Decimal(item.total_amount)
                .div(new Decimal(100))
                .toNumber();
              item.paid_amount = new Decimal(item.paid_amount)
                .div(new Decimal(100))
                .toNumber();
              this.credits.push(item);
            });
            this.receiptTotal = value.data.total;
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },
    receiptHandleSizeChange(val) {
      this.receiptPageIdx = 0;
      this.receiptPageSize = val;
      this.queryReceipts(0);
    },
    receiptHandleCurrentChange(val) {
      this.receiptPageIdx = val;
      this.queryReceipts(val - 1);
    },

    // 修改备注
    submit(row) {
      if (row.tmpComment != row.comment) {
        const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
        axios({
          method: "post",
          url: "orders/edit",
          data: {
            id: row.id,
            comment: row.tmpComment,
          },
        })
          .then((value) => {
            let message = value.data.message;
            if (value.data.code === 0) {
              this.$message.success(message);
              row.comment = row.tmpComment;
            } else {
              this.$message.error(message);
            }
          })
          .catch(() => {
            this.$message.error("操作失败");
          })
          .finally(()=>{
            loading.close();
          });
        // .finally(() => {
        //     this.query(this.pageIdx - 1);
        //   });
      }
    },
    async showDialogUpload() {
      this.uploadOrgID = this.$route.query.orgID
      this.dialogUploadVisible = true;
    },
    uploadClose(done) {
      clearInterval(interval);
      this.pageIdx = 0;
      this.query(0);
      done();
    },

    deleteItem(item) {
      let _vue = this;
      this.$confirm(`是否删除该记录？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
        axios({
          method: "post",
          url: "banks/records/delete",
          data: {
            id: item.id,
            name: item.name,
          },
        })
          .then((value) => {
            if (value.data.code === 0) {
              this.$message.success(value.data.message);
            } else {
              this.$message.error(value.data.message);
            }
          })
          .finally(() => {
            loading.close();
            if (this.listData.length == 1) {
              _vue.query(_vue.pageIdx - 2);
            } else {
              _vue.query(_vue.pageIdx - 1);
            }
          });
      });
    },
    handleCurrentChange(val) {
      this.pageIdxPai = val;
      this.query(val - 1);
    },
    handleSizeChange(val) {
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },
    handleCurrentChangePai(val) {
      this.pageIdxPai = val;
      this.query(val - 1);
    },
    handleSizeChangePai(val) {
      this.pageIdxPai = 0;
      this.pageSizePai = val;
      this.query(0);
    },
    handleCurrentChangeCheck(val) {
      this.pageIdxCheck = val;
      this.query(val - 1);
    },
    handleSizeChangeCheck(val) {
      this.pageIdxCheck = 0;
      this.pageSizeCheck = val;
      this.query(0);
    },

    // 手动对账功能
    artificialCheck(id) {
      this.checkDialogVisible = true;
      this.formCheck = {};
      this.formCheck.id = id;
    },
    // 保存对账数据
    checkSave() {
      if (!this.formCheck.checkType) {
        this.$message.error("请先选择支付渠道");
        return;
      }
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "banks/records/check",
        data: this.formCheck,
      })
        .then((value) => {
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.checkDialogVisible = false;
            // this.pageIdx = this.pageIdx-1;
            this.query(this.pageIdx - 1);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();        });
    },

    handleSelectionChange(val) {
      this.orderIdList = [];
      val.forEach((item) => {
        this.orderIdList.push(item.id);
      });
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },

    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageIdx: pageIdx,
        queryType: this.queryType,
        timeSort: this.timeSort, //开始时间排序方式
        receipt: this.queryReceipt,
        nameOrPhone: this.nameOrPhone,
        houseName: this.houseName,
      };
      if (this.payType) {
        data.payType = this.payType;
      }
      if (this.type) {
        data.type = this.type;
      }

      if (this.queryType == "支付明细") {
        data.pageSize= this.pageSizePai
        if (Array.isArray(this.paidDate)) {
          data.paidStart = parseInt(this.paidDate[0].getTime() / 1000);
          data.paidEnd = parseInt(
            this.paidDate[1].getTime() / 1000 + 60 * 60 * 24 - 1
          );
        }
        // data.paidStart = parseInt(this.paidDate.getTime() / 1000);
        // data.paidEnd = parseInt(
        //   this.paidDate.getTime() / 1000 + 60 * 60 * 24 - 1
        // );

        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
        let baseURL = axios.defaults.baseURL.replace("/v1", "/v2"); // 使用v2版本接口
        axios({
          method: "post",
          url: `${baseURL}orders`,
          data: data,
        })
          .then((value) => {
            this.listData = [];
            this.itemTotal = value.data.total;
            if (value.data.code != 0) {
              this.$message.error(value.data.message);
              return;
            }
            if (this.queryType == "银行对账") { // TODO 这个逻辑多余
              this.itemTotal = this.checkList.length;
            } else {
              this.itemTotal = value.data.total;
            }
            if (value && value.data && value.data.data) {
              value.data.data.forEach((item) => {
                item.paidTime = Utils.long2second(item.paidTime * 1000);
                item.fee = item.fee / 100;
                item.unpaidAmountStr = item.unpaidAmount / 100;
                item.totalAmountStr = item.totalAmount / 100;
                item.edit = false;
                item.tmpComment = "";
                this.listData.push(item);
              });
            }
          })
          .catch((e) => {
            this.$message.error("网络异常！");
          })
          .finally(() => {
            loading.close();
          });
      } else {
        data.pageSize= this.pageSizeCheck
        if (Array.isArray(this.dateRangeCheck)) {
          data.start = parseInt(this.dateRangeCheck[0].getTime() / 1000);
          data.end = parseInt(
            this.dateRangeCheck[1].getTime() / 1000 + 60 * 60 * 24 - 1
          );
        }
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });

        this.checkList = [];
        axios({
          method: "post",
          url: "banks/records",
          data: data,
        })
          .then((value) => {
            if (value.data.code != 0) {
              this.$message.error(value.data.message);
              return;
            }
            this.itemTotal = value.data.total;
            if (value && value.data && value.data.data) {
              value.data.data.forEach((item) => {
                item.tradeDate = Utils.long2day(item.tradeDate);
                item.daiNum = parseFloat(item.dai)
                item.checkTime = Utils.long2second(item.checkTime * 1000);
                this.checkList.push(item);
              });
            }
          })
          .catch(() => {})
          .finally(() => {
            loading.close();
          });
      }
    },
    //导出报表
    async exportFile() {
      let data = {};
      if (Array.isArray(this.dateRangeCheck)) {
        data.paidStart = parseInt(this.dateRangeCheck[0].getTime() / 1000);
        data.paidEnd = parseInt(
          this.dateRangeCheck[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }
      if (!data.start && !data.paidStart) {
        this.$message.error("请先选择对账时段");
        return;
      }

      let file = "";

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      await axios({
        method: "post",
        url: "orders/export",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            loading.close();
            this.$message.error(value.data.message);
          } else {
            file = value.data.data;
          }
        })
        .catch(() => {});

      if (file == "") return; // 没有获取到文件名时，不启动下载

      let baseURL = axios.defaults.baseURL.replace("/v1/org", "");

      await axios({
        method: "get",
        url: `${baseURL}public/${file}`,
        responseType: "blob",
      })
        .then((value) => {
          Utils.convertRes2Blob(file, value);
          this.$message.success("文件下载成功");
        })
        .catch((e) => {
          this.$message.error(e.toString());
        })
        .finally(() => {
          loading.close();
        });
    },
    changeItemState(state) {

      let _vue = this;
      return (orderID) => {
        const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
        axios({
          method: "post",
          url: "orders/invoices/mark",
          data: {
            orderID: orderID,
            invoiceFlag: state,
          },
        })
          .then((_) => {})
          .catch((_) => {})
          .finally((_) => {
            loading.close();
            _vue.query(_vue.pageIdx - 1);
          });
      };
    },

    long2day(time) {
      return Utils.long2day(time * 1000);
    },
  },
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.header-title {
  text-align: end;
  width: 150px;
  margin-right: 15px;
}
</style>

<style scoped lang="scss">
@import "../../style.css";
.item-title {
  text-align: start;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.item-main {
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.item-line {
  width: 100%;
  height: 1px;
  background: gray;
}
.box-card {
  width: 300px;
}
.item-main-plus {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item {
  font-weight: bold;
  font-size: 25px;
}
</style>
